export default __webpack_public_path__ + "static/blob11-5c9fe89c3ae282b05bccca3b815f3c2e.svg";